
import OccyNewLogoIcon from "../../../app/components/svgIcons/OccyNewLogoIcon";
import * as Yup from 'yup';

export const basicCopywriteValidation = {
    elevatorPitch: Yup.string()
        .test(
            'characterLimit',
            'Character limit exceeded max character limit',
            function (value) {
                const { jobDescription, jobRequirement } = this.parent;
                const totalCharacters =
                    (value || '').length +
                    (jobDescription?.length || 0) +
                    (jobRequirement?.length || 0);

                // If total characters exceed limit, skip validation (return true)
                if (totalCharacters > 5500) {
                    return true;
                }

                return totalCharacters <= 5500 || totalCharacters === 0;
            }
        ),
    jobDescription: Yup.string()
        .test(
            'characterLimit',
            'Character limit exceeded max character limit',
            function (value) {
                const { elevatorPitch, jobRequirement } = this.parent;
                const totalCharacters =
                    (elevatorPitch?.length || 0) +
                    (value || '').length +
                    (jobRequirement?.length || 0);

                if (totalCharacters > 5500) {
                    return true;
                }

                return totalCharacters <= 5500 || totalCharacters === 0;
            }
        ),
    jobRequirement: Yup.string()
        .test(
            'characterLimit',
            'Character limit exceeded max character limit',
            function (value) {
                const { elevatorPitch, jobDescription } = this.parent;
                const totalCharacters =
                    (elevatorPitch?.length || 0) +
                    (jobDescription?.length || 0) +
                    (value || '').length;

                if (totalCharacters > 5500) {
                    return true;
                }

                return totalCharacters <= 5500 || totalCharacters === 0;
            }
        ),
};


export const copyWriterVersionTab = [
    {
        id: 1,
        title: `Original`,
        active: true,
    },
    {
        id: 2,
        title: 'Copy Version 1',
        icon: <OccyNewLogoIcon color="#EC008C" />,
        active: false,
    },
    {
        id: 3,
        title: 'Copy Version 2',
        icon: <OccyNewLogoIcon />,
        active: false,
    }
];

export const copywriteType = [
    {
        label: 'Job Template',
        value: 'JOB_TEMPLATE',
    },
    {
        label: 'Job',
        value: 'JOB',
    }

];
export const copywriteStatus = [
    {
        label: 'Completed',
        value: 'COMPLETED',
    },
    {
        label: 'In review',
        value: 'IN_REVIEW',
    },
    {
        label: 'Revision Requested',
        value: 'REVISION_REQUESTED',
    },
    {
        label: 'In progress',
        value: 'IN_PROGRESS',
    },
    {
        label: 'Requested',
        value: 'REQUESTED',
    },
];

export const CopywriteSort = [
    {
        id: 1,
        label: 'None',
        value: 'requestedOn',
        dir: 'DESC',
        match: "checked1"
    },
    {
        id: 2,
        label: 'Title (A to Z)',
        value: 'title',
        dir: 'ASC',
        match: "checked2"
    },
    {
        id: 3,
        label: 'Title (Z to A)',
        value: 'title',
        dir: 'DESC',
        match: "checked3"
    },
    {
        id: 4,
        label: 'Company (A to Z)',
        value: 'company',
        dir: 'ASC',
        match: "checked4"
    },
    {
        id: 5,
        label: 'Company (Z to A)',
        value: 'company',
        dir: 'DESC',
        match: "checked5"
    },
    {
        id: 6,
        label: 'Requested on (Oldest to Newest)',
        value: 'requestedOn',
        dir: 'ASC',
        match: "checked6"
    },
    {
        id: 7,
        label: 'Requested (Newest to Oldest)',
        value: 'requestedOn',
        dir: 'DESC',
        match: "checked7"
    },
];
const formatValidationError=(error)=> {
  const errors = [];
  if (error.constraints) {
    for (const constraintKey in error.constraints) {
      if (error.constraints[constraintKey]) {
        errors.push(`${error.property}: ${error.constraints[constraintKey]}`);
      }
    }
  }

  if (error.children && error.children.length > 0) {
    error.children.forEach(child => {
      errors.push(...formatValidationError(child));
    });
  }

  return errors;
}
export const processValidationErrors = (errorResponse) => {
  let errorMessages = [];
if((errorResponse?.data?.message || errorResponse?.data?.msg) && !errorResponse.data?.response){
  return errorResponse?.message || errorResponse?.msg;
}else{
  if (errorResponse && errorResponse.data.response && errorResponse.data.response.errors) {
    errorResponse.data.response.errors.forEach((error) => {
      errorMessages = formatValidationError(error);
      // const propertyName = error.property;
      // const constraints = Object.values(error.constraints).join(', '); // Join all constraints

      // errorMessages.push(`${propertyName}: ${constraints || 'Validation failed'}`);
    });
  } else {
    errorMessages.push('Invalid error response format');
  }

  return errorMessages&& errorMessages?.length > 0 && errorMessages?.join(', '); // Join array elements into a single string
}
};